import {
  get, map, identity, union, intersection, pick, mapKeys, isObject, isEmpty, isDate
} from 'lodash'

export const property = (path, defaultValue = undefined) => (obj) => get(obj, path, defaultValue)

export const mapToObject = (collection, mapping = identity) => Object.assign({},
  ...map(collection, mapping))

export const fromKeys = (keys, mapping) => {
  const realMapping = (mapping instanceof Function) ? key => mapping(key) : () => mapping
  return mapToObject(keys, key => ({
    [key]: realMapping(key)
  }))
}

export const intersectionTable = (...collections) => {
  const table = fromKeys(union(...collections), false)
  const intersect = intersection(...collections)
  return {
    ...table,
    ...fromKeys(intersect, true)
  }
}

export const mapProps = (
  object,
  mappingObject
) => {
  const objectKeys = Object.keys(object)
  const mappingKeys = Object.keys(mappingObject)
  const iterationKeys = intersection(mappingKeys, objectKeys)
  const mapped = fromKeys(iterationKeys, key => mappingObject[key](object[key]))

  return { ...object, ...mapped }
}
export const renameProps = (obj, mapping) => mapKeys(obj, (_, key) => mapping[key] || key)

export const reform = (obj, mapping) => renameProps(pick(obj, Object.keys(mapping)), mapping)

export const notEmpty = val => (isObject(val) ? isDate(val) || !isEmpty(val) : Boolean(val))

export default {
  property,
  mapToObject,
  mapProps,
  fromKeys,
  intersectionTable,
  renameProps,
  reform,
  notEmpty
}
